import { actions } from './actions'

const employer = (state = { id: null, name: null }, action) => {
  switch (action.type) {
    case actions.set:
      return action.employer
    case actions.resetCurrentEmployer:
      return { id: null, name: null }
    default:
      return state
  }
}

export default employer



// WEBPACK FOOTER //
// ./src/store/current-employer/reducer.js